/* eslint-disable no-param-reassign */
import { post } from '@tencent/pmd-network';
import { Toast } from '@tencent/pmd-widget/lib/toast';
import { dateFormat } from '@tencent/pmd-tools/lib/time';
import { tcssReport as report, reportCommData } from '@tencent/pmd-report';
import { isQQNumber, isMobile } from '@tencent/pmd-tools/lib/validate';
import * as phoneUtil from '@tencent/pmd-tools/lib/phone';
import {
  postGetBindRelation,
  postGetBindToken,
  postUpdateUserPhone,
  postSendTelMsgCode,
} from 'src/component/logic/tip-merchant/user/bindrelation.js';
import cookie from 'js-cookie';
import * as miniJumpLogic from '@tencent/pmd-vue/lib/minijump';
import { getGameCurrentRole, getLolSubAreaList } from 'src/component/logic/tip-merchant/role/role.js';
import get from 'lodash-es/get';
import { initEnv } from '@tencent/pmd-tools/lib/env';
import ProtocolInfo from './protocol';
import { getConfig } from '@tencent/pmd-config';
import { UserInfo } from '@tencent/pmd-tools/lib/user-info';
import {
  GAME_PVP,
  GAME_LOLM,
  GAME_CF,
  GAME_LIFE,
  GAME_GP,
  GAME_MAJIANG,
  GAME_HLDDZ,
} from '@tencent/pmd-tools/lib/game';
import { GoodsConfigInfo } from '@tencent/pmd-config/lib/goods';
import { ConfigInfo } from '@tencent/pmd-config/lib/project';
import { showComponentDialog } from '@tencent/pmd-tools/lib/dialog-displayer';
import * as Share from '@tencent/pmd-widget/lib/share';
import Vue from 'vue';
import { jumpToPageCommon } from 'src/component/logic/tip-merchant/jump-handle/helper';

// 物品展示类型 1 端游礼包发放/ 2 手游礼包发放 /3 游豆 /4 QB发放 /5 实物邮寄
// 6 腾讯VIP类/ 7 红包 /20 离线cdkey /21 线下核销 /22 手机号兑换
// 23 兑换成功之后需要跳转地址 /25回调核销券 /26汉堡王 /28微信代金券 /29照片 /30 奈雪的茶
// 34 壁纸类型
// 传递的参数water：返回的water
// 传递的参数mWater： 自己处理的mWater，用于页面展示，包含点击事件等等，由getGoodDetail返回
// 查询物品详情
const getGoodDetail = function (winningtime, url = '') {
  return new Promise((resolve, reject) => {
    // 处理下orderid
    // 为兼容新老逻辑，winningtime参数可以为单独的winningtime或者winningtime-orderid的格式
    let orderid = '';
    if (typeof winningtime.indexOf === 'function' && winningtime.indexOf('-') !== -1) {
      const params = winningtime.split('-');
      winningtime = params[0] || '';
      if (params.length > 1) {
        orderid = params[1] || '';
      }
    }
    const reqData = {
      winningtime: parseInt(winningtime),
      orderid: `${orderid}`,
    };
    post({
      url: url
        || GoodsConfigInfo.instance.queryGoodsDetailInfoV1Url
        || '/gmp.welfarecgi.gift.gift/QueryGoodsDetailInfoV1',
      reqData,
    })
      .then((res) => {
        // res.water.status = 4;
        // res.water.goodscfg.displaytype = 1;
        // res.water.goodscfg.gid = 26;
        // res.water.cdkey = '123';
        // resolve({ originWater: res.water, ...res.water });
        // res.water.goodscfg.displaytype = 35;
        parseWaterDetail(res.water)
          .then((mwater) => {
            resolve(mwater);
          })
          .catch((error) => {
            console.log('parseWaterDetail ERROR', error);
            reject(error);
          });
      })
      .catch((error) => {
        console.log('getGoodDetail ERROR', error);
        reject(error);
      });
  });
};

// 整理物品详情数据
const parseWaterDetail = function (resWater) {
  return new Promise((resolve) => {
    const water = Object.assign({}, resWater);
    const mWater = Object.assign({}, resWater);
    mWater.originWater = water; // 原始的water信息，用于兑换的时候传参数

    // 处理基础信息
    handleWaterBasicInfo(water, mWater);

    // 处理“标为已用”类的物品
    handleWaterUsedInfo(water, mWater);

    // 处理手机号和QQ等
    handleWaterQQAndPhone(water, mWater);

    // 处理二维码和照片
    handleWaterQRCodeAndPic(water, mWater);

    // 处理邮寄地址相关
    handleWaterAddress(water, mWater);

    // 处理跳转小程序
    handleWaterMiniProgram(water, mWater);
    // 处理外部H5跳转
    handleWaterH5Jump(water, mWater);

    // 特殊处理微信商家券28
    handleWaterWeixinMerchantTicket(water, mWater);

    // 处理红包类型
    handleWaterRedPackage(water, mWater);

    // 处理自选礼包
    if (water.goodscfg.displaytype == 31 && (water.goodscfg.extra?.choose_treasure || 0) === 1) {
      mWater.showChooseGift = false;
    }

    const env = initEnv();
    if (!env.isInGame && (water.goodscfg.extra?.send_inform || 0) === 1) {
      mWater.isShowSendInformRole = true;
    }

    if (!env.isInGame && (water.goodscfg.extra?.exchange_channel || 0) === 1) {
      mWater.isShowInGameOpenTips = true;
    }

    // 特殊处理端游道具礼包
    handleLoLPcGift(water, mWater);

    // 判断兑换码类型
    if (mWater.displayType === 2
      && !mWater.vipNumber
      && !mWater.wechatCard
      && mWater.cdkey && mWater.cdkey.length > 0) {
      mWater.displayCdKey = mWater.cdkey;
    }

    // 处理进阶礼包
    handleExtraGiftInfo(water, mWater);

    // 2、3、4是否需要显示按钮
    handleWaterShowButton(water, mWater);
    // 微信券且为QQ用户，需要先请求得到微信和QQ的绑定关系
    if (water.goodscfg.displaytype == 28 && (app.tip_utype || UserInfo.tipUtype()) == 1) {
      mWater.getBindToken = getBindToken;
      mWater.onChangeWx = onChangeWx.bind(mWater);
      mWater.isBindWechat = true;

      if (water.extrainfo && water.extrainfo.wx_nick && water.extrainfo.wx_nick.length > 0) {
        mWater.wxNick = water.extrainfo.wx_nick;
      }

      // 请求绑定关系
      postGetBindRelation(app.tip_uid || UserInfo.tipUid())
        .then((response) => {
          mWater.isBindWechat = true;
          mWater.bindNick = response.dst_nickname;
          if (!mWater.wxNick) {
            mWater.wxNick = mWater.bindNick;
          }
        })
        .catch((error) => {
          mWater.isBindWechat = false;
          console.log('postGetBindRelation', error);
        })
        .then(() => {
          if (!mWater.isBindWechat) {
            mWater.goodscfg.recvway = '此券会发放到你的微信账号，请绑定微信账号领取';
            mWater.recvWay = '此券会发放到你的微信账号，请绑定微信账号领取';
          }
          console.log('mWater', mWater);
          resolve(mWater);
        });
    } else {
      console.log('mWater', mWater);
      resolve(mWater);
    }
  });
};

// 处理基础信息
function handleWaterBasicInfo(water, mWater) {
  // 展示名称
  mWater.displayName = water.goodscfg.goodsname + (get(water, 'goodscfg.extra.benefit_tag', '') || '');
  // 兑换有效期
  mWater.displayOverduetime = getOverDueTime(water.overduetime);
  // 前端用于区分的展示类型
  mWater.displayType = handleDisplayType(water, mWater);
  // 适用门店/品牌
  mWater.displayShop = handleShop(water, mWater);
  // 优惠力度
  mWater.benefitTag = get(water, 'goodscfg.extra.benefit_tag');
  // 使用限制
  mWater.useLimit = get(water, 'extrainfo.echange_water_log.use_limit');
  // 微信券使用说明插图
  mWater.couponPic = get(water, 'extrainfo.echange_water_log.coupon_pic');
  // 特别说明
  mWater.specialStatement = get(water, 'goodscfg.extra.special_statement');

  // 兑换手机号标题相关
  if (get(water, 'goodscfg.extra.goods_brand_info')) {
    mWater.displayPhoneTitle = '兑换至您的商户账号';
    mWater.brandName = water.goodscfg.extra.goods_brand_info.brand_name;
    mWater.brandIcon = water.goodscfg.extra.goods_brand_info.brand_logo;
    mWater.brandId = water.goodscfg.extra.goods_brand_info.brand_id;
  }

  // 适用门店/品牌-跳转
  mWater.clickDisplayShop = onShopClick.bind(mWater);
  // 是否有clickDisplayShop方法，小程序不支持props传function
  mWater.hasClickDisplayShop = true;
  // 进阶礼包
  if (get(water, 'goodscfg.extra.cycgift.name')) {
    mWater.displayCycgift = get(water, 'goodscfg.extra.cycgift');
    // 进阶礼包过期时间
    mWater.displayCycgift.displayOverduetime = getOverDueTimeExtra(get(water, 'goodscfg.extra.cycgift.overduetime', 0));
  }

  // 判断展示二维码/二维码图片/链接
  if (water.goodscfg.displaytype == 21 && !!water.code && water.code.length) {
    mWater.displayQRCode = true;
  } else if (water.goodscfg.displaytype == 29
    && !!water.goodscfg.maid
    && water.goodscfg.maid.length > 0
    && water.picShowType != 100) {
    mWater.displayQRCodeImage = true;
  } else if (water.goodscfg.displaytype == 29 && water.picShowType == 100) {
    mWater.displayUrl = true;
  }

  // 处理跳转外部链接的物品
  mWater.h5JumpUrl = get(water, 'goodscfg.extra.not_mail_cfg.h5_jump_url');

  // 处理使用方式
  mWater.recvWay = mWater.goodscfg.recvway;
  if (mWater.displayType == 3 && !mWater.recvWay) {
    mWater.recvWay = '请向营业员出示此码兑换';
  }
}

// 处理“标为已用”的浮层提示
function handleWaterUsedInfo(water, mWater) {
  // 处理“标为已用”/“点击立即使用”类型
  if (water.goodscfg.displaytype != 32
    && water.goodscfg.displaytype != 28
    && water.goodscfg.displaytype != 26) {
    mWater.isflagUse = true;
  }

  mWater.showConfirmDialog = false;
  // 兑换点击事件
  mWater.exchangeClick = onClickExchange.bind(mWater);
  // 标记为已使用
  mWater.flagUsedClick = flagUsed.bind(mWater);
  // 端游道具点击事件
  mWater.loLRoleSelectClick = loLRoleSelect.bind(mWater);
  // 点击核销类型
  mWater.onClickCavUserGoods = cavUserGoods.bind(mWater);
  mWater.showFlagUsedDone = false;
  // 25未使用物品，提示标记已用
  if (
    !mWater.showFlagUsedDone
    && mWater.goodscfg.displaytype == 25
    && mWater.status == 4
  ) {
    // 显示“标为已用”的浮层
    mWater.showFlagUsed = true;
    mWater.showFlagUsedDone = true;
    setTimeout(() => {
      mWater.showFlagUsed = false;
    }, 2000);
  }
}

// 处理QQ和手机号等
function handleWaterQQAndPhone(water, mWater) {
  // 填写QQ号相关
  mWater.DialogQqInput = false;
  // 是否修改手机号
  mWater.isUpdatePhone = false;
  mWater.inputQQNumber = '';
  mWater.onConfirmQQnumber = onConfirmQQnumber.bind(mWater);

  // 填写手机号相关
  mWater.showProtocolContent = false; // 查看协议的弹窗
  mWater.showUserProtocolContent = false; // 查看协议的弹窗
  mWater.DialogPhoneInput = false;  // 填写手机号的弹窗
  mWater.DialogPhoneModify = false;   // 修改手机号的弹窗
  mWater.onConfirmPhone = onConfirmPhone.bind(mWater);
  mWater.onConfirmUpdatePhone = onConfirmUpdatePhone.bind(mWater);
  mWater.onUpdatePhone = onUpdatePhone.bind(mWater);
  mWater.onGetVeriCode = onGetVeriCode.bind(mWater);
  mWater.isDisableGetCode = false;
  mWater.getCodeText = '获取验证码';
  mWater.remark = get(water, 'goodscfg.extra.olcoupon_cfg.remark');
  mWater.isActiveCoupon = get(water, 'goodscfg.extra.olcoupon_cfg.is_active_coupon'); // 是否是需要激活的券，是的话，不展示填写手机号
  mWater.protocolName = get(water, 'goodscfg.extra.protocol_name');
  mWater.protocolContent = get(water, 'goodscfg.extra.protocol_content');
  mWater.onClickProtocol = onClickProtocol.bind(mWater); // 点击手机号协议

  mWater.userProtocolName = ProtocolInfo.instance.getUserInfoAuthorizeName();
  mWater.userProtocolContent = ProtocolInfo.instance.getUserInfoAuthorizeProtocol(mWater.brandName);
  ProtocolInfo.instance.requestGetUserInfoAuthorizeProtocol(mWater.brandName)()
    .then((response) => {
      mWater.userProtocolContent = response;
    });
  mWater.onClickUserProtocol = onClickUserProtocol.bind(mWater); // 点击手机号用户协议

  // 展示的用户手机号
  if (water.useraddr?.mobile) {
    mWater.vipNumber = water.useraddr.mobile;
    mWater.showVipNumber = phoneUtil.hidePhone(mWater.vipNumber);
  }
  if (water.extrainfo?.modify_mobile) {
    mWater.monifyMobile = water.extrainfo.modify_mobile;

    if (mWater.monifyMobile.length > 8) {
      mWater.showMonifyMobile = phoneUtil.hidePhone(mWater.monifyMobile);
    }
  }
  mWater.inputPhone = mWater.monifyMobile || mWater.vipNumber;
  mWater.showInputPhone = phoneUtil.hidePhone(mWater.inputPhone, false);

  // 填写手机号上报相关
  mWater.onReportCancelPhone = onReportCancelPhone;
  mWater.onReportConfirmPhone = onReportConfirmPhone;
}

// 处理二维码和照片
function handleWaterQRCodeAndPic(water, mWater) {
  mWater.showQrCode = get(water, 'goodscfg.extra.cbcoupon_cfg.show_qr_code');

  // 照片显示类型
  mWater.picShowType = get(water, 'goodscfg.extra.pic_cfg.show_type', 0);
}

// 处理邮寄地址相关
function handleWaterAddress(water, mWater) {
  // isAddressDone地址是否已填写
  mWater.isAddressDone = get(water, 'goodscfg.displaytype') == 5 && water.status == 4 && water.useraddrtype == 2;
  mWater.DialogAddressInput = false;
  mWater.onConfirmAddress = onConfirmAddress.bind(mWater);
  if (water.useraddr) {
    mWater.inputAddress = Object.assign({}, water.useraddr); // 这里不能直接传引用
  } else {
    mWater.inputAddress = {};
  }

  mWater.onUpdateAddress = onUpdateAddress.bind(mWater);
  mWater.isUpdateAddress = false;
}

// 处理跳转小程序
function handleWaterMiniProgram(water, mWater) {
  if (water.goodscfg
    && water.goodscfg.extra
    && water.goodscfg.extra.mproc_jmp_cfg
    && water.goodscfg.extra.mproc_jmp_cfg.mproc_appid) {
    mWater.showJumpMiniProgram = true;
    mWater.miniProgramQrcode = water.goodscfg.extra.mproc_jmp_cfg.mproc_qrcode;
    mWater.miniProgramName = water.goodscfg.extra.mproc_jmp_cfg.mproc_name;
    mWater.miniProgramSourceId = water.goodscfg.extra.mproc_jmp_cfg.mproc_source_id;
    mWater.miniProgramJumpUrl = water.goodscfg.extra.mproc_jmp_cfg.mproc_jumpurl;
  }
  if (water.goodscfg.displaytype == 35 && water.goodscfg.extra.mproc_or_h5_jump === 0) {
    mWater.showJumpMiniProgramButtonText = '去小程序使用';
  }
  mWater.showJumpMiniProgramTip = false;

  const gid = app.tip_gid || getConfig('game.gid');
  // 麻将oppo渠道去掉跳转
  if (gid == 304) {
    const ua = navigator.userAgent.toLowerCase();
    let isOppo = ua.match(/(oppo|pacm00|pact00|paam00|pchm10|pedm00|pegm00|pdsm00|pdpm00|pdpt00|pdhm00|rmx2111|rmx2030)/i);
    const oppoList = ['oppo r7 build/ktu84p',
      'oppo r7t build/ktu84p',
      'r7007 build/jls36c',
      'r2017 build/jls36c',
      'r6007 build/jls36c',
      '1105 build/ktu84p',
      'n5117 build/jls36c',
      'm571c build/lmy47d',
      'r7plus build/lrx21m',
      'x909t build/jdq39',
      'a31t build/ktu84p',
      'a31 build/ktu84p',
      'r8207 build/ktu84p',
      'r833t build/jdq39'];
    oppoList.forEach((item) => {
      if (ua.indexOf(item) !== -1) {
        isOppo = true;
      }
    });
    if (isOppo) {
      mWater.showJumpMiniProgram = false;
      report.ReportHotTag('isOppo', false, false);
    } else {
      report.ReportHotTag('isNoOppo', false, false);
    }
  }
  // 英雄联盟手游屏蔽小程序
  const env = initEnv();
  if (env.isInGame && window.location.href.indexOf('nes.slol.qq.com') !== -1) {
    mWater.showJumpMiniProgram = false;
  }

  const brandList = ConfigInfo.instance.gpBrandWhiteList;
  if (mWater.showJumpMiniProgram === true && typeof brandList !== 'undefined') {
    if (brandList.indexOf(water.goodscfg.extra.goods_brand_info.brand_id) !== -1) {
      mWater.showJumpMiniProgram = true;
    } else {
      mWater.showJumpMiniProgram = false;
    }
  }
}

// 处理跳转小程序
function handleWaterH5Jump(water, mWater) {
  if (water.goodscfg.displaytype == 35
    && (water.goodscfg.extra.mproc_or_h5_jump === 1 || water.goodscfg.extra.mproc_or_h5_jump === 2)) {
    mWater.showJumpH5ButtonText = water.goodscfg.extra.mproc_or_h5_jump === 1 ? '去小程序领取使用' : '参与优惠活动';
    if (water.goodscfg?.extra?.h5_jump_cfg?.h5_jumpurl) {
      mWater.h5JumpUrl = water.goodscfg.extra.h5_jump_cfg.h5_jumpurl;
    }
  }
}

// 处理红包类型相关
function handleWaterRedPackage(water, mWater) {
  if (mWater.goodscfg.displaytype === 7) {
    // qq环境才能兑换红包
    if ((app.tip_utype || UserInfo.tipUtype()) == 1
      && initEnv().isQQ
      && !initEnv().isMiniProgram
      && water.cdkey
      && water.redpack_account_status === 1) {
      window.location.href = `https://mqq.tenpay.com/mqq/hongbao/receive.shtml?_wv=2098179&c=2&l=${water.cdkey}`;
    }
  }
}

// 特殊处理微信商家券28
function handleWaterWeixinMerchantTicket(water, mWater) {
  mWater.dialogBind = false;  // 显示绑定微信二维码和小程序码的弹窗
  mWater.onClickJumpMiniProgram = onClickJumpMiniProgram.bind(mWater, mWater);
  if (water.goodscfg.displaytype == 28) {
    if ((!water.cdkey || water.cdkey.length == 0) && water.status == 4) {
      mWater.goodscfg.recvway = '此券还未发放成功，请点击“立即兑换”兑换奖励。';
    } else {
      mWater.goodscfg.recvway = mWater.goodscfg.recvway || '此券已经发放到你的微信账号，请到微信-我-卡包-券和礼品卡查看。';
    }
    mWater.bindWechatExchange = !water.cdkey || water.cdkey.length == 0;
    mWater.isBindWechat = true;
    mWater.wechatCard = true;
    if (app.tip_utype == 2 || UserInfo.tipUtype() == 2) {
      mWater.wxNick = get(water, 'extrainfo.wx_nick') || app.tip_nick || UserInfo.tipNick();
    } else {
      mWater.needBindWechat = true;
    }
  }
}

// 特殊处理端游道具
function handleLoLPcGift(water, mWater) {
  if (water.goodscfg.gid == 26 && water.goodscfg.displaytype === 1) {
    mWater.needRoleSelect = true;
    mWater.roleSelect = false;
    mWater.lolSubAreaList = [];
    mWater.role = {};
    mWater.role.roleIdx = '';
    mWater.role.roleName = '';
    getLolSubAreaList()
      .then((subAreaList) => {
        mWater.lolSubAreaList = subAreaList;
      });
    mWater.onConfirmRoleSelect = onConfirmRoleSelect.bind(mWater);
  }
}

// 2、3、4是否需要显示按钮
function handleWaterShowButton(water, mWater) {
  mWater.haveButton = mWater.status == 4
    && ((mWater.displayType == 2 && mWater.goodscfg.displaytype != 30
        && mWater.goodscfg.displaytype != 28 && mWater.goodscfg.displaytype != 26)
      || (mWater.displayType == 4 && mWater.picShowType == 100)
      || mWater.goodscfg.displaytype == 32
      || (water.needBindWechat && !water.isBindWechat)
      || mWater.bindWechatExchange
      || mWater.showJumpMiniProgram
    );
}

const realHandleDisplayType = function (water, mWater) {
  const goodscfg = water.goodscfg || {};
  let displaytype = goodscfg.displaytype || '';
  displaytype = displaytype.toString();

  if (['20', '21', '25', '26', '28', '29', '30', '32'].indexOf(displaytype) === -1) {
    return 0;
  }
  if ((displaytype == 26 || displaytype == 30) && (!water.cdkey || water.cdkey.length == 0)) {
    return 1;
  }
  if (displaytype == 20 || displaytype == 28 || displaytype == 30
    || ((displaytype == 25 || displaytype == 26) && !mWater.show_qr_code)) {
    return 2;
  }
  if ((displaytype == 25 || displaytype == 26)
    && !!water.cdkey && water.cdkey.length > 0) {
    return 3;
  }
  return 4;
};

// 处理前端展示的类型 0:普通类型 1:核销码-未解锁 2:奈雪的茶 3:核销码-二维码+条形码 4:核销码-二维码
const handleDisplayType = function (water, mWater) {
  mWater.show_qr_code = get(water, 'goodscfg.extra.cbcoupon_cfg.show_qr_code')
    || get(water, 'goodscfg.extra.olcoupon_cfg.show_qr_code');
  return realHandleDisplayType(water, mWater);
};

// 处理过期时间
const getOverDueTime = function (time) {
  if (time) {
    const d = new Date(time * 1000);
    return `${dateFormat(d, 'yyyy.MM.dd')}`;
  }
  return '永久有效';
};

// 处理进阶礼包最后兑换时间
const getOverDueTimeExtra = function (time) {
  if (time) {
    const d = new Date(time * 1000);
    return dateFormat(d, 'yyyy.MM.dd');
  }
  return '有效期';
};

// 处理进阶礼包最后兑换时间
const getOverDueTimeTreasure = function (time) {
  if (time) {
    const d = new Date(time * 1000);
    return dateFormat(d, 'yyyy-MM-dd');
  }
  return '';
};

// 处理适用商家名称
const handleShop = function (water, mWater) {
  if (!!water.extrainfo
    && !!water.extrainfo.echange_water_log
    && water.extrainfo.echange_water_log.is_offline_store) {
    mWater.isOfflineStore = true;
    return `${water.extrainfo.echange_water_log.store_name}等${water.extrainfo.echange_water_log.store_num}家门店可用`;
  }
  if (!!water.goodscfg.extra
    && !!water.goodscfg.extra.mproc_jmp_cfg
    && !!water.goodscfg.extra.mproc_jmp_cfg.mproc_name) {
    return water.goodscfg.extra.mproc_jmp_cfg.mproc_name.indexOf('小程序') == -1
      ? `${water.goodscfg.extra.mproc_jmp_cfg.mproc_name}小程序`
      : water.goodscfg.extra.mproc_jmp_cfg.mproc_name;
  }
  if (!!water.goodscfg.extra && !!water.goodscfg.extra.goods_brand_info) {
    return water.goodscfg.extra.goods_brand_info.brand_name;
  }
  if (water.goodscfg.provider) {
    return water.goodscfg.provider;
  }
  if (water.goodscfg.merchant) {
    return water.goodscfg.merchant.storename + water.goodscfg.merchant.addr;
  }
};

// 处理进阶礼包
const handleExtraGiftInfo = function (water, mWater) {
  if (water.goodscfg.extra && water.goodscfg.extra.cycgift) {
    mWater.extraGiftName = water.goodscfg.extra.cycgift.name;
    mWater.extraGiftImg = water.goodscfg.extra.cycgift.gift_pic;
    mWater.limitDate = `${mWater.displayOverduetime}前到店兑换上述物品后，额外送：`;
  }
  if (water.goodscfg.extra && water.goodscfg.extra.treasure_cfg) {
    mWater.chooseGift = water.goodscfg.extra.choose_treasure === 1;
    mWater.giftList = water.goodscfg.extra.treasure_cfg.gift_list || [];
    mWater.limitDate = `${mWater.displayOverduetime}前到店兑换上述物品后`;

    mWater.giftList.forEach((item) => {
      item.leftGiftCount = (item.totallimit || 10000) - (item.total_expend || 0);
      if (item.leftGiftCount <= 0) {
        item.leftGiftTips = '余量为0，无法兑换';
      } else {
        item.leftGiftTips = `库存：${item.leftGiftCount}`;
      }
    });
  }
};

/** ***** 下面是点击事件的处理 *********/

// 处理适用商家点击事件
const onShopClick = function () {
  const mWater = this;
  if (!!mWater.extrainfo
    && mWater.extrainfo.echange_water_log
    && mWater.extrainfo.echange_water_log.is_offline_store) {
    gotoBrandMercList(mWater);
  } else if (!mWater.isOfflineStore
    && mWater.showJumpMiniProgram
    && process?.env?.VUE_APP_PLATFORM === 'mp-weixin') {
    miniJumpLogic.handleGetMiniProgramOpenLink(1, mWater, {})
      .then(() => {
      })
      .catch(() => {
      });
  } else if (mWater.showJumpMiniProgram) {
    onClickJumpMiniProgram(mWater);
  } else if (!!mWater.goodscfg.extra && !!mWater.goodscfg.extra.goods_brand_info) {
    gotoBrandPage(mWater);
  } else if (mWater.goodscfg.merchant) {
    gotoMerchant(mWater);
  }
};

// 上报确定手机号
const onReportConfirmPhone = function (water = {}) {
  const waterGiftId = water.giftid || '';
  const waterActId = water.actid || '';
  report.ReportHotTag(`click_button.${waterActId}.${waterGiftId}_confirm`, false, false);
};

const onReportCancelPhone = function (water = {}) {
  const waterGiftId = water.giftid || '';
  const waterActId = water.actid || '';
  report.ReportHotTag(`click_button.${waterActId}.${waterGiftId}_cancel`, false, false);
};

// 跳转商家详情
const gotoMerchant = function (mWater) {
  const { merchantid } = mWater.goodscfg.merchant;
  jumpToPageCommon({ path: `/merchant/detail/${merchantid}`, query: { frompage: 1 } });
};

// 跳转品牌主页
const gotoBrandPage = function (mWater) {
  const brandid = mWater.goodscfg.extra.goods_brand_info.brand_id;
  if (getConfig().isCrossPlatform) {
    // 小程序只能通过query传参，城市峡谷用这个路由path；
    jumpToPageCommon({ path: '/views/brand/detail', query: { brandid, frompage: 1 } });
  } else {
    jumpToPageCommon({ path: `/brand/detail/${brandid}`, query: { frompage: 1 } });
  }
};

// 跳转活动链接（H5链接）
export const gotoExtraAct = function (url) {
  // const mWater = this;
  if (self !== top && top) {
    top.location.href = url;
  } else {
    window.location.href = url;
  }
};

const gotoBrandMercList = function (mWater) {
  const brandid = mWater.goodscfg.extra.goods_brand_info.brand_id;
  const actid = mWater.extrainfo.echange_water_log.act_stock_id;
  jumpToPageCommon({ path: `/brand/merc-list/${brandid}/${actid}/3`, query: { frompage: 1 } });
};

// 点击兑换按钮
const onClickExchange = function (url = '') {
  const mWater = this;
  const water = this.originWater;

  // 处理领取物品的参数
  switch (mWater.goodscfg.displaytype) {
    case 1:
    case 2:
    case 31:
      // 这里要判断特殊状态执行添加角色的接口
      if (mWater.goodscfg.displaytype !== 31 || (mWater.goodscfg.displaytype === 31 && mWater.chooseGift)) {
        if (water.goodscfg.gid === GAME_PVP && mWater.role) {
          if (!water.role) {
            water.role = {};
          }
          water.role.roleIdx = mWater.role.roleIdx;
          water.role.roleName = mWater.role.roleName;
          water.role.subAreaName = mWater.role.subAreaName;
          water.role.RoleBaseInfo = {};
          water.role.RoleBaseInfo.roleidx = mWater.role.roleIdx;
          water.role.RoleBaseInfo.gid = app.tip_gid || getConfig('game.gid');
          // water.role.RoleBaseInfo.subarea = parseInt(getPvpPartition() || '0');
        } else if (water.goodscfg.gid === GAME_LOLM) {
          water.role = {};
          water.role = { RoleBaseInfo: { device: initEnv().isIOS ? 1 : 2 } };
        } else if (water.goodscfg.gid === GAME_CF) { // 这里是为游戏人生做的，是个集合页，只能取water的gid
          if (mWater?.role?.subarea) {
            water.role = { RoleBaseInfo: { subarea: mWater.role.subarea } };
          } else {
            Toast.show('请先选择大区，再兑换');
            return;
          }
        } else if (isCommonGoods(water.goodscfg.gid)) {
          // 如果为自选礼包，不做角色强校验
          if (mWater.role?.roleIdx || (mWater.goodscfg.displaytype === 31 && mWater.chooseGift)) {
            if (!water.role) {
              water.role = {};
            }
            water.role.roleIdx = mWater.role?.roleIdx;
            water.role.roleName = mWater.role?.roleName;
            water.role.subAreaName = mWater.role?.subAreaName;
            water.role.RoleBaseInfo = {};
            water.role.RoleBaseInfo.roleidx = mWater.role?.roleIdx;
            water.role.RoleBaseInfo.gid = app.tip_gid || getConfig('game.gid');
          } else {
            Toast.show('请先选择角色，再兑换');
            return;
          }
        } else {
          getGameCurrentRole()
            .then((role) => {
              water.role = {};
              water.role.roleIdx = role.role_base_info.roleidx;
              // eslint-disable-next-line no-extra-boolean-cast
              water.role.roleName = !!role.role_base_info.rolename
                ? role.role_base_info.rolename
                : app.tip_nick || UserInfo.tipNick();
              water.role.subAreaName = (app.tip_utype || UserInfo.tipUtype()) == 1 ? 'QQ大区' : '微信大区';
              water.role.RoleBaseInfo = {};
              water.role.RoleBaseInfo.roleidx = role.role_base_info.roleidx;
              water.role.RoleBaseInfo.gid = app.tip_gid || getConfig('game.gid');
              exchangeGift(water, mWater, url);
            })
            .catch(() => {
              Toast.showFail('当前帐号还没有角色，请先进入游戏创建角色');
            });
          return;
        }
      }
      break;
    case 4: // Q币类型，需要校验手机号
      mWater.remark = '通过手机号验证后，QB将会发放到您的QQ账户，请注意查收';
      mWater.DialogPhoneInput = true;
      mWater.needPhoneCheck = true;
      mWater.userProtocolName = '';
      mWater.verificationCode = '';
      return;
    case 7: // 红包类型，需要校验手机号
      if ((app.tip_utype || UserInfo.tipUtype()) == 1 && !initEnv().isQQ) {
        let shareUrl = '';
        const { gid } = water.goodscfg;
        const isTest = window.location.origin.indexOf('test') !== -1;
        if ([GAME_PVP, GAME_GP, GAME_HLDDZ, GAME_MAJIANG].includes(gid)) {
          const { styleName } = ConfigInfo.instance.getConfig();
          if ((styleName === 'smoba-vertical' || styleName.includes('smoba-vertical')) && window.location.href.indexOf('/my-award-detail') !== -1) {
            shareUrl = `${window.location.origin}${window.location.pathname}#/my-award-detail/${mWater.winningtime}-${mWater.orderid}`;
          } else {
            shareUrl = `${window.location.origin}${window.location.pathname}#/goods/detail/${mWater.winningtime}-${mWater.orderid}`.replace('ingame-page/ingame', 'ingame-page/igame');
          }
        } else if (gid === GAME_LOLM) {
          shareUrl = `https://h5${isTest ? '-test' : ''}.nes.slol.qq.com/slolnes.web.igame-lolm${isTest ? '.develop' : ''}/#/views/goods/detail?winningtime=${mWater.winningtime}-${mWater.orderid}`;
        } else {
          shareUrl = `https://${isTest ? 'test.' : ''}igame.qq.com/tip/ingame-page/igame-game-life/#/goods/detail/${mWater.winningtime}-${mWater.orderid}?gid=${gid}`;
        }
        showComponentDialog(new Vue(), () => import('src/component/ui/tip-merchant/tip-comp-dialog-prompt/index.vue'), {
          show: true,
          isShowByFunction: true,
          propsData: {
            title: '提示',
            content: '分享兑换链接到QQ内打开，即可兑换',
            subContent: `为了保证红包能顺利到账，请分享或复制一下链接在QQ内打开兑换（使用当前登录的QQ账号）：${shareUrl}`,
            btnText: '分享页面到QQ',
          },
          clickButtonCallback: () => {
            Share.initShare({
              title: '我的物品',
              desc: `点我兑换${mWater.goodscfg.goodsname}`,
              icon: mWater.goodscfg.goodsicon,
              link: shareUrl,
            });
            if (document.getElementsByClassName('share-type-1')?.length > 0) {
              document.getElementsByClassName('share-type-1')[0].parentElement.style.display = 'none';
            }
            if (document.getElementsByClassName('share-type-2')?.length > 0) {
              document.getElementsByClassName('share-type-2')[0].parentElement.style.display = 'none';
            }
            if (document.getElementsByClassName('share-type-4')?.length > 0) {
              document.getElementsByClassName('share-type-4')[0].parentElement.style.display = 'none';
            }
            Share.openShareUI();
          },
        })
          .then(() => {
          });
      } else {
        if ((app.tip_utype || UserInfo.tipUtype()) == 1) {
          mWater.remark = '输入手机号验证后，【QQ钱包】会发送到账通知';
        } else {
          mWater.remark = '输入手机号验证后，【游戏人生微信公众号】会发送到账通知';
        }
        mWater.DialogPhoneInput = true;
        mWater.needPhoneCheck = true;
        mWater.userProtocolName = '';
        mWater.verificationCode = '';
      }
      return;
    case 5:
      // 填写地址
      mWater.DialogAddressInput = true;
      return;
    case 22:
    case 26:
    case 30:
      // 填写手机号
      mWater.DialogPhoneInput = true;
      return;
  }
  return exchangeGift(water, mWater, url);
};

// 请求兑换物品接口
const exchangeGift = function (water, mWater, url = '') {
  Toast.showLoading({
    duration: 0,
    forbidClick: true,
    message: '请稍候...',
  });
  mWater.showConfirmDialog = false;
  return postGetExchange(
    water,
    {
      maskPhone: mWater.maskPhone,
      maskPhoneFlagId: mWater.maskPhoneFlagId,
      chooseGiftId: mWater.chooseGiftInfo?.giftid,
      code: mWater.verificationCode,
    },
    url,
  )
    .then((res) => {
      if (water.goodscfg.displaytype == 26 || water.goodscfg.displaytype == 20) {
        Toast.showSuccess('发放成功，快去使用吧', 300);
      } else if (water.goodscfg.displaytype == 5 && mWater.isUpdateAddress) {
        Toast.showSuccess('修改地址成功');
      } else if (water.goodscfg.displaytype == 31) { // 宝箱类物品处理弹窗
        if (water.goodscfg.extra.choose_treasure === 1) {
          console.log('自选礼包');
          mWater.showChooseGift = false;
        } else {
          console.log('兑换宝箱');
          let treasureWater = {};
          treasureWater = res.water.extrainfo.treasurewaterinfo.ok_gift;
          const tmp = res.water.extrainfo.treasurewaterinfo.overduetime;
          treasureWater.displayOverduetime = getOverDueTimeTreasure(tmp);
          treasureWater.winningtime = res.water.extrainfo.treasurewaterinfo.winningtime;
          const treasureCode = res.water.extrainfo.treasurewaterinfo.retcode;
          console.log('兑换宝箱 treasureWater', treasureWater);
          console.log('兑换宝箱 treasureCode', treasureCode);
          if (treasureWater && Object.keys(treasureWater).length && treasureCode == 0) {
            app.$ebus.emit('showTreasureDialog', treasureWater); // 这里因为刷新water不能关闭领奖弹窗，所以用总线事件处理
          } else {
            Toast.showFail('很遗憾，没有中奖哦，再接再厉哦');
          }
        }
      } else {
        Toast.showSuccess('兑换成功');
      }

      console.log('兑换成功');
      app.$ebus.emit('refreshwaterdetail');
      app.$ebus.emit('refreshwaterlist_after_exchange');

      if (mWater.exchangeCallBack) {
        let tempWater = null;
        if (res && res.water) {
          tempWater = res.water;
        }
        mWater.exchangeCallBack(tempWater);
      }
      return res;
    })
    .catch((error) => {
      console.log('兑换失败', error);
      mWater.exchangeFailCallBack && mWater.exchangeFailCallBack();
      return error;
    })
    .finally(() => {
      Toast.dismissLoading();
    });
};

const getBindToken = function () {
  return new Promise((resolve) => {
    let bindToken = 'no token';
    // 请求用于绑定的token
    postGetBindToken()
      .then((response) => {
        const gid = app.tip_gid || getConfig('game.gid');
        const host = window.location.origin.indexOf('test') !== -1 ? 'https://test.igame.qq.com/' : 'https://igame.qq.com/';
        const url = GoodsConfigInfo.instance.bindWeixinUrl
          || `${host}/tip/ingame-page/igame-wechat-related/index.html#/`;
        bindToken = `${url}${response.token_info.token}/${gid}/${response.token_info.uid}`;
        if (cookie.get('msdk_openid_game')) {
          bindToken = `${url}${response.token_info.token}/${gid}/${response.token_info.uid}/${cookie.get('msdk_openid_game')}`;
        }
        resolve(bindToken);
      })
      .catch((error) => {
        console.log('postGetBindToken', error);
        resolve(bindToken);
      });
  });
};

const postGetExchange = function (water, extraInfo = {}, url = '') {
  return new Promise((resolve, reject) => {
    const reqData = { water };

    // 以下是网关取号逻辑，可以不用填入手机号，兑换物品
    if (extraInfo?.maskPhone && extraInfo?.maskPhoneFlagId) {
      reqData.mask_mobile = extraInfo.maskPhone;
      reqData.mobileFlagId = extraInfo.maskPhoneFlagId;
    }

    // 以下是自选礼包逻辑，需要上传选中的礼包id
    if (extraInfo?.chooseGiftId) {
      reqData.choose_treasure_giftid = extraInfo.chooseGiftId;
    }

    // 以下是现金红包和Q币逻辑，需要上传手机号验证码
    if (extraInfo?.code) {
      reqData.code = extraInfo.code;
    }

    // 标识兑换来源
    reqData.exchange_param = { source: app.isMpWeixin ? 'wxproc' : 'h5' };

    post({
      url: url
        || GoodsConfigInfo.instance.exchangeUrl
        || '/gmp.welfarecgi.gift.gift/Exchange',
      reqData,
    })
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        console.log('/gmp.welfarecgi.gift.gift/Exchange', error);
        reject(error);
      });
  });
};

// 标记为已使用，直接调用兑换接口，品牌券用这个
const flagUsed = function () {
  const mWater = this;
  const water = this.originWater;
  mWater.showConfirmDialog = true;
  mWater.confirmUsedData = {
    title: '标记已使用',
    content: '确认后本物品将失效',
    subContent: '请确认已使用优惠哦！',
    btnText: '确认',
    cancelBtnText: '取消',
  };
  mWater.confirmUsed = exchangeGift.bind(mWater, water, mWater);
};

// 确认为已使用，调用核销的接口，散户券用这个
const cavUserGoods = function () {
  const mWater = this;
  const water = this.originWater;
  mWater.showConfirmDialog = true;
  mWater.confirmUsedData = {
    title: '确认已使用',
    content: '确认后，此物品变为“已使用”状态，不可重复使用',
    subContent: '请确认已使用优惠哦！',
    btnText: '确认',
    cancelBtnText: '取消',
  };
  mWater.confirmUsed = postCavUserGoodsReq.bind(mWater, water, mWater);
};

const loLRoleSelect = function () {
  const mWater = this;
  const water = this.originWater;
  mWater.roleSelect = true;
  mWater.onConfirmRoleSelect = onConfirmRoleSelect.bind(mWater, water, mWater);
};

// 确定QQ号
const onConfirmQQnumber = function () {
  const mWater = this;
  const water = this.originWater;
  if (!mWater.inputQQNumber || !isQQNumber(mWater.inputQQNumber)) {
    mWater.inputQQNumber = '';
    Toast.showFail('请填写正确的QQ号码');
  } else {
    mWater.DialogQqInput = false;
    water.recvuid = mWater.inputQQNumber;
    exchangeGift(water, mWater);
  }
};

// 确定手机号
const onConfirmPhone = function () {
  const mWater = this;
  const water = this.originWater;
  if ((!mWater.inputPhone || !isMobile(mWater.inputPhone)) && (!mWater.maskPhone || !mWater.maskPhoneFlagId)) {
    mWater.inputPhone = '';
    Toast.show('请填写正确的手机号码');
  } else if (mWater.needPhoneCheck && !mWater.verificationCode) {
    Toast.show('请填写验证码');
  } else if (mWater.protocolName && mWater.protocolName.length && !mWater.isAgreeProtocol) {
    Toast.show('请勾选协议再进入下一步');
  } else {
    if (!water.useraddr) {
      water.useraddr = {};
    }
    mWater.DialogPhoneInput = false;
    water.useraddr.mobile = mWater.inputPhone;
    // 填写QQ号码
    if (mWater.goodscfg.displaytype === 4 && (app.tip_utype || UserInfo.tipUtype()) != 1) {
      mWater.DialogQqInput = true;
    } else if (mWater.goodscfg.displaytype === 4 && ConfigInfo.instance.getConfig().projectName === 'web/user') {
      // 如果是赛宝内兑换q币，由于王者荣耀openid不能直接兑换Q币，所以要手动填写
      mWater.DialogQqInput = true;
    } else {
      exchangeGift(water, mWater);
    }
  }
};

// 确定修改手机号
const onConfirmUpdatePhone = function () {
  const mWater = this;
  if ((!mWater.inputPhone || !isMobile(mWater.inputPhone)) && (!mWater.maskPhone || !mWater.maskPhoneFlagId)) {
    mWater.inputPhone = '';
    Toast.show('请填写正确的手机号码');
  } else if (!mWater.verificationCode && (!mWater.maskPhone || !mWater.maskPhoneFlagId)) {
    Toast.show('请填写验证码');
  } else {
    // 绑定手机号与品牌
    const reqData = { brandid: mWater.brandId };
    if (mWater.maskPhone && mWater.maskPhoneFlagId) {
      reqData.mask_mobile = mWater.maskPhone;
      reqData.mobileFlagId = mWater.maskPhoneFlagId;
    } else {
      reqData.phone = mWater.inputPhone;
      reqData.code = mWater.verificationCode;
    }
    postUpdateUserPhone(reqData)
      .then((response) => {
        console.log('postUpdateUserPhone', response);
        mWater.vipNumber = response.phone || mWater.inputPhone;
        mWater.DialogPhoneModify = false;
        Toast.show('修改成功，\n将在下次领取时生效');
        app.$ebus.emit('refreshwaterdetail');
      })
      .catch((error) => {
        app.$set(mWater, 'maskPhone', '');
        app.$set(mWater, 'maskPhoneFlagId', '');
        console.log('postUpdateUserPhone', error);
      });
  }
};

// 修改手机号
const onUpdatePhone = function () {
  const mWater = this;
  mWater.displayPhoneTitle = '修改手机号码';
  mWater.DialogPhoneModify = true;
  mWater.isUpdatePhone = true;
};

// 获取手机验证码
const onGetVeriCode = function () {
  const mWater = this;
  if (!mWater.inputPhone) {
    Toast.show('请输入手机号');
    return;
  }
  if (mWater.isDisableGetCode) {
    return;
  }
  const reqData = {
    mobile: mWater.inputPhone,
  };

  // 验证码倒计时
  let timeo = 60;
  mWater.isDisableGetCode = true;
  mWater.getCodeText = `重新发送${timeo}s`;
  const timeStop = setInterval(() => {
    timeo = timeo - 1;
    if (timeo > 0) {
      mWater.isDisableGetCode = true;
      mWater.getCodeText = `重新发送${timeo}s`;
    } else {
      timeo = 60;
      mWater.getCodeText = '获取验证码';
      clearInterval(timeStop);// 清除定时器
      mWater.isDisableGetCode = false;
    }
  }, 1000);

  postSendTelMsgCode(reqData)
    .then((response) => {
      console.log('postSendTelMsgCode', response);
      Toast.show('验证码已发送');
    })
    .catch((error) => {
      console.log('postSendTelMsgCode', error);
      // 请求失败直接去掉定时器
      mWater.getCodeText = '获取验证码';
      clearInterval(timeStop);// 清除定时器
      mWater.isDisableGetCode = false;
    });
};

// 确定邮寄地址
const onConfirmAddress = function () {
  const mWater = this;
  const water = this.originWater;
  if (!mWater.inputAddress.name || !mWater.inputAddress.name.length) {
    Toast.showFail('收件人姓名不能为空');
  } else if (!mWater.inputAddress.mobile || !mWater.inputAddress.mobile.length) {
    Toast.showFail('收件人手机号不能为空');
  } else if (!isMobile(mWater.inputAddress.mobile)) {
    Toast.showFail('请填写正确的手机号码');
  } else if (!mWater.inputAddress.district || !mWater.inputAddress.district.length) {
    Toast.showFail('收件人地区不能为空');
  } else if (!mWater.inputAddress.detail_addr || !mWater.inputAddress.detail_addr.length) {
    Toast.showFail('收件人详细地址不能为空');
  } else if (
    water.useraddr
    && water.useraddr.name == mWater.inputAddress.name
    && water.useraddr.mobile == mWater.inputAddress.mobile
    && water.useraddr.province == mWater.inputAddress.province
    && water.useraddr.city == mWater.inputAddress.city
    && water.useraddr.district == mWater.inputAddress.district
    && water.useraddr.detail_addr == mWater.inputAddress.detail_addr
    && water.useraddr.zipcode == mWater.inputAddress.zipcode
    && water.status !== 4
  ) {
    Toast.showFail('地址信息未修改');
  } else {
    mWater.DialogAddressInput = false;
    water.useraddr = mWater.inputAddress;
    console.log('water::', water);
    exchangeGift(water, mWater);
  }
};

// 查看协议
const onClickProtocol = function () {
  const mWater = this;
  mWater.showProtocolContent = true;
};

// 查看协议
const onClickUserProtocol = function () {
  const mWater = this;
  mWater.showUserProtocolContent = true;
};

const onUpdateAddress = function () {
  const mWater = this;
  mWater.isUpdateAddress = true;
  onClickExchange.call(mWater);
};

const onChangeWx = function () {
  const mWater = this;
  getBindToken()
    .then((url) => {
      mWater.dialogBind = true;
      mWater.dialogBindUrl = url;
      mWater.dialogBindTitle = '扫码关联微信号';
    });
};

// 点击跳转小程序
const onClickJumpMiniProgram = function (mWater, reqData) {
  const water = mWater.originWater;
  // 上报小程序跳转礼包ID
  report.ReportHotTag('click_goto_mini_program', false);
  if (initEnv().isMiniProgram && initEnv()
    .ua
    .indexOf(water.goodscfg.extra.mproc_jmp_cfg.mproc_appid) !== -1) {
    // #ifdef H5
    const wxSdk = window.wx || require('weixin-js-sdk');
    wxSdk.miniProgram.navigateBack();
    // #endif
  } else {
    // 获取小程序跳转链接，并跳转
    miniJumpLogic.handleGetMiniProgramOpenLink(
      1,
      water,
      {},
      reqData,
    )
      .then((url) => {
        if (url) {
          window.location.href = url;
        }
      })
      .catch((error) => {
        if (mWater.dialogBindUrl) {
          console.log('handleGetMiniProgramOpenLink', error);
          mWater.dialogBind = true;
          mWater.dialogBindUrl = mWater.miniProgramQrcode;
          mWater.dialogBindTitle = `前往${mWater.miniProgramName}小程序使用`;
        } else {
          Toast.show(`前往${mWater.miniProgramName}小程序使用`);
        }
      });
  }
  postReportGoodsJump(water, mWater);
};

const onConfirmRoleSelect = function () {
  const mWater = this;
  const water = this.originWater;
  if (!mWater.role.roleIdx) {
    Toast.showFail('请选择大区角色');
  } else {
    water.role = {};
    water.role.roleIdx = mWater.role.roleIdx;
    water.role.roleName = mWater.role.roleName;
    exchangeGift(water, mWater);
  }
};

const postReportGoodsJump = function (water, mWater) {
  const reqData = {
    oper_name: 'merchant_goocvt',
    event_id: 'miniprogram_jump',
    second_channel: 'goods_detail',
    brand_id: mWater.brandId,
    // eslint-disable-next-line no-extra-boolean-cast
    act_id: !!mWater.extrainfo.echange_water_log ? mWater.extrainfo.echange_water_log.actid : '',
    gift_id: `${mWater.giftid}`,
    goods_id: `${mWater.goodsid}`, // 物品id
    goods_type: `${mWater.goodscfg.goodstype}`, // 物品类型
    target_page_first_channel: 'miniprogram',
    target_page_second_channel: 'miniprog_redirect',
    create_first_channel: get(water, 'extrainfo.echange_water_log.src_channel'),
    create_second_channel: get(water, 'extrainfo.echange_water_log.src_module'),
    target_type: 'miniprogram',
  };
  reportCommData(reqData);
};

const postCavUserGoodsReq = function (water) {
  const params = {
    merchantid: water.goodscfg && water.goodscfg.merchant && water.goodscfg.merchant.merchantid ? water.goodscfg.merchant.merchantid : '',
    code: water.code,
    opflag: 0,
    gid: app.tip_gid || getConfig('game.gid'),
  };
  post({
    url: '/gmp.welfarecgi.gift.gift/CavUserMerchantGoods',
    reqData: params,
  })
    .then(() => {
      Toast.showSuccess('核销成功');
      app.$ebus.emit('refreshwaterdetail');
      app.$ebus.emit('refreshwaterlist_after_exchange');
    })
    .catch(() => {
      app.$ebus.emit('refreshwaterdetail');
      app.$ebus.emit('refreshwaterlist_after_exchange');
    });
};

/**
 * 是否为游戏人生通用物品表处理格式
 *
 * @param {int} gid 游戏ID
 */
const isCommonGoods = function (gid) {
  return ConfigInfo.instance.getTipGid() === GAME_LIFE
    || ![GAME_PVP, GAME_LOLM, GAME_GP, GAME_HLDDZ, GAME_MAJIANG].includes(gid);
};

export default {
  getGoodDetail,
  parseWaterDetail,
  onUpdateAddress,
  onConfirmAddress,
  onConfirmPhone,
  onClickProtocol,
  getBindToken,
  exchangeGift,
  onClickExchange,
  gotoBrandPage,
  gotoMerchant,
  onReportCancelPhone,
  onReportConfirmPhone,
  onShopClick,
  handleShop,
  getOverDueTimeTreasure,
  getOverDueTimeExtra,
  getOverDueTime,
  handleDisplayType,
  realHandleDisplayType,
  handleWaterShowButton,
  handleWaterWeixinMerchantTicket,
  handleWaterAddress,
  handleWaterQRCodeAndPic,
  handleWaterQQAndPhone,
  handleWaterUsedInfo,
  handleWaterBasicInfo,
  onConfirmQQnumber,
  cavUserGoods,
  postGetExchange,
  flagUsed,
  onClickJumpMiniProgram,
  onGetVeriCode,
  onConfirmUpdatePhone,
  onClickUserProtocol,
  onChangeWx,
  onUpdatePhone,
  loLRoleSelect,
  onConfirmRoleSelect,
  isCommonGoods,
};

export {
  getGoodDetail,
  parseWaterDetail,
  onUpdateAddress,
  onConfirmAddress,
  onConfirmPhone,
  onClickProtocol,
  getBindToken,
  exchangeGift,
  onClickExchange,
  gotoBrandPage,
  gotoMerchant,
  onReportCancelPhone,
  onReportConfirmPhone,
  onShopClick,
  handleShop,
  getOverDueTimeTreasure,
  getOverDueTimeExtra,
  getOverDueTime,
  handleDisplayType,
  realHandleDisplayType,
  handleWaterShowButton,
  handleWaterWeixinMerchantTicket,
  handleWaterAddress,
  handleWaterQRCodeAndPic,
  handleWaterQQAndPhone,
  handleWaterUsedInfo,
  handleWaterBasicInfo,
  onConfirmQQnumber,
  cavUserGoods,
  postGetExchange,
  flagUsed,
  onClickJumpMiniProgram,
  onGetVeriCode,
  onConfirmUpdatePhone,
  onClickUserProtocol,
  onChangeWx,
  onUpdatePhone,
  loLRoleSelect,
  onConfirmRoleSelect,
  isCommonGoods,
};

